// Action Types
export const FETCH_SETTINGS_REQUEST = 'FETCH_SETTINGS_REQUEST';
export const FETCH_SETTINGS_SUCCESS = 'FETCH_SETTINGS_SUCCESS';
export const FETCH_SETTINGS_FAILURE = 'FETCH_SETTINGS_FAILURE';

export const UPDATE_SETTINGS_REQUEST = 'UPDATE_SETTINGS_REQUEST';
export const UPDATE_SETTINGS_SUCCESS = 'UPDATE_SETTINGS_SUCCESS';
export const UPDATE_SETTINGS_FAILURE = 'UPDATE_SETTINGS_FAILURE';

// Action Creators for Fetching Settings
export const fetchSettingsRequest = () => ({
  type: FETCH_SETTINGS_REQUEST,
});

export const fetchSettingsSuccess = (data) => ({
  type: FETCH_SETTINGS_SUCCESS,
  payload: data,
});

export const fetchSettingsFailure = (error) => ({
  type: FETCH_SETTINGS_FAILURE,
  payload: error,
});

// Action Creators for Updating Settings
export const updateSettingsRequest = (key, value) => ({
  type: UPDATE_SETTINGS_REQUEST,
  payload: { [key]:value },
});

export const updateSettingsSuccess = (data) => ({
  type: UPDATE_SETTINGS_SUCCESS,
  payload: data,
});

export const updateSettingsFailure = (error) => ({
  type: UPDATE_SETTINGS_FAILURE,
  payload: error,
});
